const getView = (route) => {
  const { name, path, meta, fullPath, query } = route
  return {
    name,
    path,
    fullPath: fullPath || path,
    query: query || {},
    title: (meta && meta.title) || '未命名',
  }
}

export default {
  namespaced: true,
  state: {
    visitedViews: [],
  },
  mutations: {
    ADD_VISITED_VIEW(state, view) {
      if (!view.path || state.visitedViews.some((v) => v.path === view.path)) return
      state.visitedViews.push(Object.assign({}, view))
    },
    DEL_VISITED_VIEW(state, view) {
      state.visitedViews = state.visitedViews.filter((v) => v.path !== view.path)
    },
    DEL_OTHERS_VIEWS(state, view) {
      state.visitedViews = state.visitedViews.filter(
        (v) => v.path === view.path || v.meta?.affix
      )
    },
    DEL_ALL_VIEWS(state) {
      state.visitedViews = state.visitedViews.filter((v) => v.meta?.affix)
    },
  },
  actions: {
    addView({ commit }, route) {
      if (!route.meta || !route.meta.title || route.meta.layout == 0) return
      commit('ADD_VISITED_VIEW', getView(route))
    },
    delView({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEW', view)
        resolve([...state.visitedViews])
      })
    },
  },
}
